import $ from 'jquery';
import {isPhone} from './useragent';

/// Hoverflip-Effekt initialisieren. Kann mehrfach aufgerufen werden,
/// wenn nachträglich neue Elemente in den DOM eingefügt werden.
export default function() {
    if (isPhone)
        return;
    $('.effect-hover-flip:not(.effect-hover-flip-active)').each((i, link) => {
        const $link = $(link);
        $link.addClass('effect-hover-flip-active');
        const text = $link.find('> span').text();
        link.dataset.content = text;
        // damit Effekt rund zuende läuft, auch wenn man die Maus wieder wegbewegt:
        $link.on('mouseenter', function(e) {
            $link.addClass('effect-hover-flip-show');
        }).on('transitionend', function(e) {
            $link.removeClass('effect-hover-flip-show');
        });
    });
}
